import { render, staticRenderFns } from "./zuhekuguanli.vue?vue&type=template&id=10ff6726&scoped=true&"
import script from "./zuhekuguanli.vue?vue&type=script&lang=js&"
export * from "./zuhekuguanli.vue?vue&type=script&lang=js&"
import style0 from "./zuhekuguanli.vue?vue&type=style&index=0&id=10ff6726&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10ff6726",
  null
  
)

export default component.exports